<div class="pt-4">
  <mat-card>
    @if (selectedBatch(); as batch) {
      <!-- Batch detail: media grid -->
      <mat-card-header class="!flex !flex-row !items-center gap-2">
        <button
          mat-icon-button
          (click)="backToList()"
          [matTooltip]="'waters.media.detail.back' | translate"
          [attr.aria-label]="'waters.media.detail.back' | translate">
          <mat-icon>arrow_back</mat-icon>
        </button>
        <div>
          <mat-card-title>{{ batch.name || '—' }}</mat-card-title>
          <mat-card-subtitle>{{ batch.email || '—' }}</mat-card-subtitle>
        </div>
      </mat-card-header>
      <mat-card-content class="!pt-4">
        <app-water-user-media-grid [waterId]="waterId()" [batchId]="batch.id" />
      </mat-card-content>
    } @else {
      <!-- Batch list -->
      <mat-card-header>
        <mat-card-title>{{ 'waters.media.title' | translate }}</mat-card-title>
        <mat-card-subtitle>{{ 'waters.media.subtitle' | translate }}</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content class="!p-0">
        <div class="overflow-x-auto">
          <table mat-table [dataSource]="batches()" class="w-full">

            <ng-container matColumnDef="submitter">
              <th mat-header-cell *matHeaderCellDef>{{ 'waters.media.column.submitter' | translate }}</th>
              <td mat-cell *matCellDef="let b" class="font-medium whitespace-nowrap">{{ b.name || '—' }}</td>
            </ng-container>

            <ng-container matColumnDef="email">
              <th mat-header-cell *matHeaderCellDef>{{ 'waters.media.column.email' | translate }}</th>
              <td mat-cell *matCellDef="let b" class="text-sm text-gray-500">{{ b.email || '—' }}</td>
            </ng-container>

            <ng-container matColumnDef="site">
              <th mat-header-cell *matHeaderCellDef>{{ 'waters.media.column.site' | translate }}</th>
              <td mat-cell *matCellDef="let b">{{ b.siteName || '—' }}</td>
            </ng-container>

            <ng-container matColumnDef="items">
              <th mat-header-cell *matHeaderCellDef>{{ 'waters.media.column.items' | translate }}</th>
              <td mat-cell *matCellDef="let b">{{ b.mediaCount }}</td>
            </ng-container>

            <!-- No-data row -->
            <tr *matNoDataRow>
              @if (!batchesResource.isLoading()) {
                <td [attr.colspan]="displayedColumns.length" class="p-0">
                  <div class="text-center p-10">
                    <mat-icon class="empty-state-icon mb-4">photo_library</mat-icon>
                    <p class="text-gray-700 text-base">{{ 'waters.media.empty' | translate }}</p>
                  </div>
                </td>
              }
            </tr>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: displayedColumns"
              (click)="openBatch(row)"
              class="cursor-pointer hover:bg-gray-50"></tr>
          </table>
        </div>

        @if (total() > 0) {
          <mat-paginator
            [length]="total()"
            [pageSize]="pageSize()"
            [pageIndex]="page() - 1"
            [pageSizeOptions]="[10, 25, 50, 100]"
            [showFirstLastButtons]="true"
            (page)="onPageChange($event)"
            class="border-t border-gray-200" />
        }
      </mat-card-content>
    }
  </mat-card>
</div>
